<template>
  <v-dialog width="500" v-model="showRejectionRemarksDialog">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Rejection Remarks </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showRejectionRemarksDialog = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="remarksForm"
          v-if="showRejectionRemarksDialog"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                label="Remarks *"
                required
                :rules="[(val) => !!val || 'Remarks is Required!']"
                hide-details="auto"
                :clearable="true"
                v-model="remarksDetails.rejection_remarks"
                :error-messages="formErrors.rejection_remarks"
                @input="delete formErrors.rejection_remarks"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="rejectCompanyRequests"
        >
          Submit
        </v-btn>

        <v-btn class="ml-3" color="secondary" depressed @click="resetForm">
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    InputField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    companyRequestID: {
      type: [Number, null],
      default: null,
    },
    companyRequestNo: {
      type: [String, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showRejectionRemarksDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      isValid: true,
      isTextInput: false,
      formErrors: {},
      remarksDetails: {},
    };
  },
  methods: {
    rejectCompanyRequests() {
      let payload = {
        id: this.companyRequestID,
        rejection_remarks: this.remarksDetails.rejection_remarks,
      };
      this.$api.user
        .rejectCompanyRequest(payload)
        .then((res) => {
          this.$emit("refreshList");
          this.showRejectionRemarksDialog = false;
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Update status!",
            color: "error",
          });
        });
    },

    resetForm() {
      if (this.$refs.remarksForm) {
        this.$refs.remarksForm.reset();
      }
      this.remarksDetails = {};
    },
  },
};
</script>
